module.exports = __webpack_public_path__ + "static/img/COC2023-4.37c44ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-4.png
// module id = qK3r
// module chunks = 0